import { LoaderCircle } from 'lucide-react';

const LoaderCircleSpin = ({
    size = 24,
    color = 'text-gray-500',
    className = '',
}: {
    size?: number;
    color?: string;
    className?: string;
}) => {
    return (
        <LoaderCircle
            className={`animate-spin ${color} ${className}`}
            width={size}
            height={size}
        />
    )
}

export default LoaderCircleSpin